import { motion } from "framer-motion";
import { Hammer, Sprout, MousePointerClick, FolderOpen, TrendingUp, Lightbulb } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { WHY_US } from "@/lib/site";

const ICONS = {
  hammer: Hammer,
  sprout: Sprout,
  pointer: MousePointerClick,
  folder: FolderOpen,
  trending: TrendingUp,
  bulb: Lightbulb,
};

export default function WhyUs() {
  return (
    <section id="why-us" className="relative py-20 md:py-28" data-testid="why-us-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeading
          eyebrow="Why Us"
          title={
            <>
              Why Choose <span className="text-brand">Motion Mind Institute?</span>
            </>
          }
        />

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 lg:gap-6">
          {WHY_US.map((f, i) => {
            const Icon = ICONS[f.icon];
            return (
              <Reveal key={f.num} delay={(i % 3) * 0.08} className="h-full">
                <motion.div
                  whileHover={{ y: -6 }}
                  transition={{ type: "spring", stiffness: 280, damping: 22 }}
                  className="group relative h-full overflow-hidden rounded-3xl border border-white/[0.07] bg-obsidian-card/80 p-7 hover:border-amber-500/35 hover:shadow-glow-amber-sm transition-all duration-500"
                  data-testid={`why-us-card-${f.num}`}
                >
                  <span className="pointer-events-none absolute -top-2 right-4 font-display text-6xl font-extrabold text-stroke opacity-60 select-none">
                    {f.num}
                  </span>
                  <div className="inline-flex h-12 w-12 items-center justify-center rounded-2xl bg-amber-500/10 border border-amber-500/25 text-amber-500 group-hover:bg-amber-500 group-hover:text-obsidian transition-all duration-400">
                    <Icon className="h-5 w-5" />
                  </div>
                  <h3 className="mt-5 font-display text-lg font-semibold text-white">{f.title}</h3>
                  <p className="mt-3 text-sm text-gray-400 leading-relaxed">{f.desc}</p>
                  <span className="absolute bottom-0 left-0 h-[2px] w-0 bg-gradient-to-r from-amber-500 to-brand group-hover:w-full transition-all duration-500" />
                </motion.div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
